import { createContext, PropsWithChildren, useState } from 'react';

import useLanguage from '../hooks/useLanguage';

export const LocalizationContext = createContext({
	languageID: '',
	setLanguageID: (languageID: string) => {},
});

export function LocalizationScope(props: PropsWithChildren<{}>) {
	const language = useLanguage();

	const [languageID, setLanguageID] = useState(language.id);

	return (
		<LocalizationContext.Provider value={{ languageID, setLanguageID }}>
			{props.children}
		</LocalizationContext.Provider>
	);
}
